// purpose:
// Registers the current screen's "Next" handler with the step action store
// so the master layout's Next button can invoke it.

import { useEffect } from "react";
import { useStepActionStore } from "../store/sendmoneyStepActionStore";

export function useStepAction(handler: () => void): void {
  const setHandler = useStepActionStore((state) => state.setHandler);

  useEffect(() => {
    setHandler(handler);
    return () => setHandler(null);
  });
}
